export default "__VITE_ASSET__g5eFJh_r__"